// Utility to construct a voice name from user settings
import { hostStyles } from '../configs/userPreferences/hostStyles';
import { findAccentConfig, findHostStyleConfig } from './getUserPreferences';
function isHostPersonality(value) {
    return hostStyles.some((style) => style.personality === value);
}
export function normalizeVoiceSettings(input) {
    return {
        accent: input.accent,
        hostStyle: input.hostStyle.personality,
        hostGender: input.hostStyle.gender,
    };
}
export function constructVoiceName(settings, fallbackVoice = 'en-US-Chirp3-HD-Orus') {
    try {
        if (!settings) {
            return fallbackVoice;
        }
        const { accent: hostAccent, hostStyle, hostGender } = settings;
        if (!isHostPersonality(hostStyle)) {
            return fallbackVoice;
        }
        const accent = findAccentConfig(hostAccent.split('-')[0], hostAccent);
        const style = findHostStyleConfig(hostStyle, hostGender);
        if (!accent || accent.disabled || !style || style.disabled) {
            return fallbackVoice;
        }
        const voiceActor = style.voiceActor;
        return `${hostAccent}-Chirp3-HD-${voiceActor}`;
    }
    catch {
        return fallbackVoice;
    }
}
//# sourceMappingURL=getVoiceName.js.map